import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React, { createContext, useState } from "react";
import SectionsHeading from "../../MainComponent/SectionsHeading";
import { CardGrid } from "../../../Styles/style";
import BorrowPageTable from "./BorrowTable";
import BorrowDetailPage from "./BorrowDetailPage";

const GridWrapper = styled(Grid)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: auto;
  column-gap: 20px;
  row-gap: 20px;
`;



export const BorrowPageContext = createContext()
const BorrowHome = () => {
  const [pageState , setPageState] = useState("home")
  return (
    <BorrowPageContext.Provider value={{pageState, setPageState}}>
    {
      pageState === "home" ? (
        <GridWrapper container>
        <CardGrid item xs={12} sx={{position:"relative"}}>
            <SectionsHeading fm="PoppinsSB" fs="16px" fs599="14px" ta="left" color="#FC9D00">
            Total Market Size
            </SectionsHeading>
          <BorrowPageTable/>
        </CardGrid>
        {/* ///////////////////////////////////////// */}
      </GridWrapper>
      ) : pageState === "1st" ?
      (
          <BorrowDetailPage/>
      ) : ("")
  }
    </BorrowPageContext.Provider>
  );
};

export default BorrowHome;
